'use strict';

angular.module('app.studies')
    .config(['$stateProvider', 'RouteProvider', function($stateProvider, RouteProvider) {
        $stateProvider.state(RouteProvider.create('studies', {
            url: '/studies',
            redirectTo: 'studies.list',
        }));

        $stateProvider.state(RouteProvider.create('studies.list', {
            url: '/list',
            component: 'studiesList',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Estudios');
            }],
            permission: 'read user studies',
            resolve: {
                initInvitationsService: ['checkPermission', 'InvitationsManager', function(checkPermission, InvitationsManager) {
                    return InvitationsManager.reload();
                }],
            },
        }));

        $stateProvider.state(RouteProvider.create('studies.create', {
            url: '/create',
            component: 'studyCreationForm',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Crear nuevo estudio');
            }],
            permission: 'create studies',
            resolve: {
                onSubmit: ['$state', function($state) {
                    return function() {
                        $state.go('studies.list');
                    };
                }],
            },
        }));

        $stateProvider.state(RouteProvider.create('studies.details', {
            url: '/:studySubdomain',
            pageTitle: ['gettextCatalog', function(gettextCatalog) {
                return gettextCatalog.getString('Detalles del estudio');
            }],
            component: 'studyMain',
            redirectTo: 'studies.details.edit',
            resolve: {
                study: ['$q', '$transition$', 'checkUserIsLogged', 'StudiesManager', function($q, $transition$, checkUserIsLogged, StudiesManager) {
                    var studyDomain = $transition$.params().studySubdomain;

                    return StudiesManager.getStudyInfo(studyDomain);
                }],
            },
        }));

        $stateProvider.state(RouteProvider.create('studies.details.edit', {
            url: '/edit',
            component: 'studyUpdateForm',
            resolve: {
                checkStudyPermission: ['$q', '$transition$', 'AccountManager', 'RouteError', function($q, $transition$, AccountManager, RouteError) {
                    var studyDomain = $transition$.params().studySubdomain;
                    var permission = 'edit study info';

                    if (!AccountManager.hasStudyPermission(studyDomain, permission)) {
                        var error = new RouteError('permission-required');

                        return $q.reject(error);
                    }
                }],
                onSubmit: ['$state', function($state) {
                    return function() {
                        return $state.go('studies.list', {
                            reload: true,
                        });
                    };
                }],
            },
        }));

        $stateProvider.state(RouteProvider.create('studies.details.subscription', {
            url: '/subscription',
            pageTitle: ['gettextCatalog', function (gettextCatalog) {
                return gettextCatalog.getString('Licencia de uso actual');
            }],
            component: 'subscriptionDetails',
            resolve: {
                checkStudyPermission: ['$q', '$transition$', 'AccountManager', 'RouteError', 'StudiesManager', function($q, $transition$, AccountManager, RouteError, StudiesManager) {
                    var studyDomain = $transition$.params().studySubdomain;
                    var permission = 'read subscription';

                    if (!AccountManager.hasStudyPermission(studyDomain, permission)) {
                        var error = new RouteError('permission-required');

                        return $q.reject(error);
                    }

                    // GARU-4678 Limpiamos preventivamente la caché de lista de estudios
                    // StudiesManager.clearData();
                }],
            },
        }));
    }]);
